import SimpleIntro from "../../components/General/SimpleIntro";
import AdvancedText from "../../components/General/AdvancedText";
import AdvancesCardList from "../../components/General/AdvancesCardList";
import AdvancedIntro from "../../components/General/AdvancedIntro";

const HotelBooking = () => {
  return (
    <section>
      <SimpleIntro urlApi="services/hotelBooking/simpleIntro" />

      <div className="container text-center">
        <div style={{ margin: "7rem auto" }}>
          <AdvancedText urlApi="services/hotelBooking/advancedText" />

          <AdvancesCardList urlApi="services/hotelBooking/hotelBookingList" />
        </div>
      </div>

      <AdvancedIntro urlApi="services/hotelBooking/advancedIntro" />
    </section>
  );
};

export default HotelBooking;
